import { render, staticRenderFns } from "./AlbumFolder.vue?vue&type=template&id=5a940713&scoped=true&"
import script from "./AlbumFolder.vue?vue&type=script&lang=js&"
export * from "./AlbumFolder.vue?vue&type=script&lang=js&"
import style0 from "./AlbumFolder.vue?vue&type=style&index=0&id=5a940713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a940713",
  null
  
)

export default component.exports